
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import SaberTypesContent from "./Components/SaberTypesContent.vue";

export default defineComponent({
  name: "SaberTypesView",
  components: {
    BreadCrumb,
    SaberTypesContent,
  },
});
